import React from "react";
import Navigation from "./Navigation";
import { ReactComponent as InfoIcon } from "images/info.svg";
class Questions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: "none",
    };
  }

  showHover = () => {
    this.setState({ display: "block" });
  };

  hideHover = () => {
    this.setState({ display: "none" });
  };

  render() {
    const itemsMobile = this.props.dataItems[this.props.name].items.map(
      (item) => (
        <div className="item-container-m" key={item.long}>
          <label>
            <div
              className={
                this.props.data == item.short ? "item item-checked" : "item"
              }
            >
              <item.icon
                className="item-icon"
                alt={item.short}
                width="30"
                height="35"
              />{" "}
              <span>{item.long}</span>
            </div>
            <input
              type="radio"
              name={this.props.name}
              value={item.short}
              onChange={this.props.handleData}
              className="is-hidden"
            />
          </label>
        </div>
      ),
    );

    const items = this.props.dataItems[this.props.name].items.map((item) => (
      <div className="item-container" key={item.long}>
        <label>
          <div
            className={
              this.props.data == item.short ? "item item-checked" : "item"
            }
          >
            <div className="img">
              <item.icon className="item-icon" alt={item.short} />
            </div>
            <div className="d-flex">
              <span
                className={this.props.data == item.short ? "text-sub2" : ""}
              >
                {item.long}
              </span>
              {item.tooltip && (
                <div
                  className="info-block-container is-hidden-mobile"
                  onMouseEnter={(e) => this.showHover(e)}
                  onMouseLeave={(e) => this.hideHover(e)}
                >
                  <div
                    className="iconColor1"
                    style={{ float: "right", marginLeft: "5px" }}
                  >
                    <InfoIcon />
                  </div>
                  <div
                    className="info-block info-block-bailleur"
                    style={{ display: this.state.display }}
                  >
                    <h3>Propriétaire bailleur : </h3>
                    <p className="mt-10">
                      <strong>Un bailleur</strong> désigne une personne physique
                      ou morale (banque, mutuelle, compagnie d'assurance),
                      généralement <strong>propriétaire</strong> d'un bien
                      immobilier et qui met celui-ci en location.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="d-flex mb-30">
            <div>
              <div>
                <input
                  type="radio"
                  name={this.props.name}
                  value={item.short}
                  onChange={this.props.handleData}
                  className="is-hidden"
                />
              </div>

              {/* <div className={this.props.data == item.short? 'square-checked':'square'}>
                  <svg width="16" height="11" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.45312 5.59251L5.27343 9.69831L14.2833 2.03833" stroke="white" strokeWidth="3"></path></svg>
                </div> */}
            </div>
            <div className={item.long.length > 18 ? "lh16" : "lh22"}></div>
          </div>
        </label>
      </div>
    ));

    return (
      <div className="fadeIn">
        <div
          className={
            this.props.dataItems[this.props.name].items.length > 3
              ? "item-wrapper is-hidden-mobile"
              : "item-wrapper jcc is-hidden-mobile"
          }
        >
          {items}
        </div>
        <div className="only-show-mobile">{itemsMobile}</div>

        <Navigation
          data={this.props.data}
          step={this.props.step}
          nextStep={this.props.nextStep}
          lastStep={this.props.lastStep}
          loadingParcours={this.props.loadingParcours}
          leadsource={this.props.leadsource}
          lastStepPrequestion={this.props.lastStepPrequestion}
        />
      </div>
    );
  }
}

export default Questions;
